// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Ge_SB","col":"styles_col__LDFvg","fulfillmentStatus":"styles_fulfillmentStatus__18uDg","emailCol":"styles_emailCol__3925E"};